import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsOvercastComponent } from './simple-icons-overcast.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsOvercastComponent ],
    exports:      [ SimpleIconsOvercastComponent ],
    bootstrap:    []
})
export class SimpleIconsOvercastModule {}
